import React, { Suspense, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from 'styled-components';
import { ConfigProvider, Spin } from 'antd';
import { store, persistor } from './redux/store';
import RouterCreate from './router/routerCreate';
import { getToken } from '@services/request';
import '@static/css/style.css';
import '@static/css/generate.less'
import { login } from '@redux/authentication/actionCreator';
import actions from '@redux/authentication/actions';
import config from './config/config';

// i18n
import './locales/index'
import { useTranslation } from 'react-i18next';


import HTTPApi from '@services';
const { getUserInfo } = HTTPApi.user;

const { theme } = config;

const ProviderConfig = ({ antdLocal }) => {
  const dispatch = useDispatch();
  const { jwt } = useSelector(state => state.auth.loginResponse);

  // if(getToken()&&!jwt){
  // 之前是以sessionStorage的机制刷新用户信息，现在是每次refresh都更新一次
  useEffect(() => {
    getToken() && getUserInfo().then(res => {
      dispatch(login());
      const lngEnum = {
        1: 'en',
        2: 'zh-CN',
        3: 'zh-HK'
      }
      React.i18n.setLocalLanguage(lngEnum[res.user.language])
      dispatch(actions.loginResponse(res));
    })
  }, [])
  // }
  const { rtl, topMenu, darkMode } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });
  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'} locale={antdLocal}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Suspense
          fallback={
            <div className="spin">
              <Spin />
            </div>
          }
        >
          <RouterCreate />
        </Suspense>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  // 配置全局i18n以及translate
  const { t, i18n } = useTranslation();
  React.t = t;
  React.i18n = i18n;


  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ProviderConfig antdLocal={i18n.antdLocal} />
      </PersistGate>
    </Provider>
  );
}

export default hot(App);
